import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled, { css } from "styled-components";

const mobile = (styles: any) => css`
  ${({ theme }) => theme?.isWidget && styles};

  @media (max-width: 768px) {
    ${styles}
  }
`;

export const WeatherDayContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const WeatherDayWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap:  ${toRem(16)};
  max-width: 1040px;
  width: 100%;
  background-color: ${COLORS.BG.ELEVATED.S};
  color: : ${COLORS.BG.PAGE_FILLED};
  border-radius:${toRem(16)};

  ${mobile(css`
    background-color: transparent;
  `)}
`;

export const WeatherTextNull = styled.p`
  font-size: ${toRem(17)};
  color: ${COLORS.FG.DEFAULT};
  text-align: center;
`;
